'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Typography_web = require('../../../atoms/Typography/Typography.web.cjs');
var Price_web_styles = require('../Price.web.styles.cjs');

/**
 * The discounted variant of the Price component.
 */ const DiscountedPrice = ({ formattedSellPrice, formattedMsrp, isCAD })=>{
    return /*#__PURE__*/ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                isStrikethrough: true,
                colorIntensity: "subtle",
                as: "span",
                isMarginless: true,
                children: formattedMsrp
            }),
            /*#__PURE__*/ jsxRuntime.jsxs(Typography_web.Typography, {
                as: "span",
                customCss: Price_web_styles.sellPrice,
                isMarginless: true,
                children: [
                    formattedSellPrice,
                    " ",
                    isCAD ? "CAD" : ""
                ]
            })
        ]
    });
};

exports.DiscountedPrice = DiscountedPrice;
//# sourceMappingURL=DiscountedPrice.web.cjs.map
